<div class="chat-widget">
  <!-- Toggle Button -->
  <button mat-fab class="chat-btn" (click)="toggleChat()" *ngIf="!isExpanded" [matTooltip]="!isCheckingSubscription && !isPremium ? 'Premium feature' : ''">
    <mat-icon>chat</mat-icon>
    <span class="badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
    <mat-icon class="lock-badge" *ngIf="!isCheckingSubscription && !isPremium">lock</mat-icon>
  </button>

  <!-- Chat Container -->
  <div class="chat-container" *ngIf="isExpanded">
    <!-- Header -->
    <div class="chat-header">
      <div class="header-left">
        <mat-icon>support_agent</mat-icon>
        <div>
          <h3>Store Assistant</h3>
          <span class="status">Online</span>
        </div>
      </div>
      <button mat-icon-button (click)="closeChat()">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Checking subscription -->
    <div class="chat-locked" *ngIf="isCheckingSubscription">
      <mat-spinner diameter="32"></mat-spinner>
    </div>

    <!-- Not entitled — upgrade prompt instead of the chat thread -->
    <div class="chat-locked" *ngIf="!isCheckingSubscription && !isPremium">
      <mat-icon class="chat-locked__icon">workspace_premium</mat-icon>
      <h4>AI Chat is a Premium feature</h4>
      <p>
        Ask questions about your products, prices, and inventory in plain
        language.
        <ng-container *ngIf="currentPlanName">You're currently on the {{ currentPlanName }} plan.</ng-container>
        Upgrade to Premium or Enterprise to unlock it.
      </p>
      <button mat-raised-button color="primary" routerLink="/billing" (click)="closeChat()">
        <mat-icon>upgrade</mat-icon>
        Upgrade Plan
      </button>
    </div>

    <ng-container *ngIf="!isCheckingSubscription && isPremium">
      <!-- Messages -->
      <div class="chat-messages" #chatMessages>
        <div *ngFor="let msg of messages"
             class="message"
             [class.user]="msg.sender === 'user'"
             [class.bot]="msg.sender === 'bot'">
          <div class="avatar" *ngIf="msg.sender === 'bot'">
            <mat-icon>smart_toy</mat-icon>
          </div>
          <div class="bubble">
            <!-- User message (plain text) -->
            <p *ngIf="msg.sender === 'user'">{{ msg.text }}</p>

            <!-- Bot message (formatted HTML) -->
            <div *ngIf="msg.sender === 'bot'" class="markdown-content" [innerHTML]="msg.html"></div>

            <span class="time">{{ msg.timestamp | date:'short' }}</span>
          </div>
          <div class="avatar" *ngIf="msg.sender === 'user'">
            <mat-icon>person</mat-icon>
          </div>
        </div>

        <div *ngIf="isLoading" class="message bot">
          <div class="avatar">
            <mat-icon>smart_toy</mat-icon>
          </div>
          <div class="bubble typing">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>

      <!-- Input -->
      <div class="chat-input">
        <button mat-icon-button (click)="clearChat()">
          <mat-icon>delete_sweep</mat-icon>
        </button>
        <input [(ngModel)]="messageInput"
               (keyup.enter)="sendMessage()"
               [disabled]="isLoading"
               placeholder="Type your message...">
        <button mat-icon-button (click)="sendMessage()" [disabled]="!messageInput.trim() || isLoading">
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </ng-container>
  </div>
</div>
